import { DatePipe, NgClass } from "@angular/common";
import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ArbetsorderInfoIconComponent } from "@components/arbetsorder-info-icon/arbetsorder-info-icon.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { ApiClientService } from "~app/common/services/api-client.service";
import { RelativePipe } from "../../../common/pipes/relative.pipe";
import { RecentDocumentDTO, RecentsDTO } from "./recent-models";

@Component({
    selector: "rask-recent",
    templateUrl: "./recent.component.html",
    styleUrls: ["./recent.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        ArbetsorderInfoIconComponent,
        NgClass,
        RouterLink,
        NgbTooltip,
        DatePipe,
        RelativePipe
    ]
})
export class RecentComponent implements OnInit {
    recents: RecentsDTO;

    private readonly api = inject(ApiClientService);

    getIcon(type: string): string {
        switch (type) {
            case "kontrakt":
                return "fad fa-handshake fa-2x";
            case "arbetsorder":
                return "fad fa-tasks-alt fa-2x";
            case "verksamhetshandelse":
                return "fa-solid fa-circle-info fa-2x";
            case "destinering":
                return "fad fa-truck fa-2x";
            default:
                return "fa-solid fa-circle-info fa-2x";
        }
    }

    getRoute(doc: RecentDocumentDTO): any[] {
        switch (doc.entity) {
            case "fpvkontrakt":
                return [
                    "skogsvardfpv/avtal",
                    doc.id
                ];
            case "kontrakt":
                return [
                    "virkeskop/avtal",
                    doc.id
                ];
            case "arbetsorder":
                return ["planera"];
            default:
                return null;
        }
    }

    getRouteParams(doc: RecentDocumentDTO): any {
        switch (doc.entity) {
            case "kontrakt":
            case "fpvkontrakt":
                return doc.secondaryId ? { kontraktId: doc.secondaryId } : null;
            case "arbetsorder":
                return doc.name ? { beteckning: doc.name } : null;
            default:
                return null;
        }
    }

    hasLink(doc: RecentDocumentDTO): boolean {
        return !!this.getRoute(doc);
    }

    ngOnInit(): void {
        this.api.get<RecentsDTO>("anvandare/recents", false).subscribe(recents => {
            this.recents = recents;
        });
    }
}
